<template>
    <table class="uk-table uk-table-small uk-table-divider">
            <thead>
                <tr>
                    <th class="uk-table-shrink">N</th>
                    <th>FirstName</th>
                    <th>LastName</th>
                    <th>Email</th>
                    <th>Company</th>
                    <td></td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(user, index) in users" :key="user.id">
                    <td>{{index + 1}}</td>
                    <td>{{user.firstName}}</td>
                    <td>{{user.lastName}}</td>
                    <td>{{user.email}}</td>
                    <td>{{user.organizationName}}</td>
                    <td>
                      <ul class="uk-iconnav s">
                          <li v-if="!user.isActive"><a href="#" uk-icon="icon: lock"></a></li>
                          <li v-if="user.isActive"><a href="#" uk-icon="icon: unlock"></a></li>
                          <li>
                              <a href="#" style="position: relative;bottom: 2px;"><span uk-icon="icon:  cog"></span></a>
                                <div uk-dropdown="mode: click;">
                                    <ul class="uk-nav uk-dropdown-nav">
                                        <li class="uk-nav-header">Roles</li>
                                        <li><label><input class="uk-checkbox" type="checkbox" value="user"> User</label></li>
                                        <li><label><input class="uk-checkbox" type="checkbox" value="manager"> Manager</label></li>
                                        <li><label><input class="uk-checkbox" type="checkbox" value="admin"> Administrator</label></li>
                                        <li class="uk-nav-divider"></li>
                                        <li><a href="#">Reset password</a></li>
                                    </ul>
                                </div>
                          </li>
                          <li><a href="#" uk-icon="icon: trash"></a></li>
                      </ul>
                    </td>
                </tr>
            </tbody>
    </table>
</template>

<script>
import UserService from '@/services/user.service';
export default {
    name: 'Users',
    data() {
        return {
            checkUser: '',
            users: []
        }
    },
    mounted() {
        UserService.getUsers().then(
            res => {
                this.users = res.data;
            },
            error => {
                console.log(error.message);
            }
        )
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
         },
        isAdmin() {
            if (this.currentUser && this.currentUser.roles) {
                return this.currentUser.roles.includes('admin');
            }
            return false;
        }
    },
    methods: {
        updateUser(data){
            UserService.updateUser(data).then(
                res => {
                    this.users.forEach((user) => {
                        if(user.id === res.data.id)
                            user = res.data;
                    });
                    this.checkUser = '';
                },
                error => {
                    console.log(error.message);
                }
            )
        }
    },
}
</script>

<style>
.uk-iconnav.s {
  position: relative;
  border: none;
}
</style>